import React from "react";
import PropTypes from "prop-types";

import CheckboxGroup from "./inputs/checkboxGroup";
import CheckboxInput from "./inputs/checkboxInput";
import SelectInput from "./inputs/selectInput";
import SelectTreeInput from "./inputs/selectTreeInput";
import TextareaInput from "./inputs/textareaInput";
import TextInput from "./inputs/textInput";
import YesOrNoInput from "./inputs/yesOrNoInput";
import RadioGroup from "./inputs/radioGroup";
import DateInput from "./inputs/dateInput";
import MarkdownInput from "./inputs/markdown";

const propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
};

const defaultProps = {
  type: "text",
};

function FormInput({ name, type, ...props }) {
  const inputProps = {
    name,
    id: name,
    "aria-describedby": `${name}Error`,
    ...props,
  };

  if (type === "date") {
    return <DateInput {...inputProps} />;
  }

  if (type === "markdown") {
    return <MarkdownInput {...inputProps} />;
  }

  if (type === "checkbox") {
    return <CheckboxInput {...inputProps} />;
  }

  // if (type === 'dropzone') {
  //   return <Dropzone {...inputProps} />;
  // }

  // if (type === 'files') {
  //   return <Files {...inputProps} />;
  // }
  if (type === "checkboxGroup") {
    return <CheckboxGroup {...inputProps} />;
  }

  if (type === "radioGroup") {
    return <RadioGroup {...inputProps} />;
  }

  if (type === "yesOrno") {
    return <YesOrNoInput {...inputProps} />;
  }

  if (type === "select") {
    return <SelectInput {...inputProps} />;
  }

  if (type === "selectTree") {
    return <SelectTreeInput {...inputProps} />;
  }

  if (type === "textarea") {
    return <TextareaInput {...inputProps} />;
  }

  return <TextInput type={type} {...inputProps} />;
}

FormInput.propTypes = propTypes;
FormInput.defaultProps = defaultProps;

export default FormInput;
